export const LogoMark = ({ className = "w-9 h-9", dark = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="18" fill={dark ? "#FCFBF7" : "#1B3B28"} />
    <path
      d="M32 12c-5 0-7.5 2.4-11.5 2.4S12 12.8 12 20.5c0 6.3 2.6 9.6 3.9 16.7 1.2 6.5 2.2 14.3 5.4 14.3 3.6 0 3.2-10.2 5.3-13 1-1.3 2.4-1.9 5.4-1.9s4.4.6 5.4 1.9c2.1 2.8 1.7 13 5.3 13 3.2 0 4.2-7.8 5.4-14.3 1.3-7.1 3.9-10.4 3.9-16.7 0-7.7-4.5-6.1-8.5-6.1S37 12 32 12z"
      fill="none"
      stroke={dark ? "#1B3B28" : "#FCFBF7"}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path d="M32 18c-5 4.6-5 11 0 15.6 5-4.6 5-11 0-15.6z" fill="#86C89B" />
    <path d="M32 20.5v11" stroke="#1B3B28" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark dark={dark} />
    <span className="leading-none text-left">
      <span className={`f-serif block text-[1.05rem] sm:text-2xl italic whitespace-nowrap ${dark ? "text-[#FCFBF7]" : "text-[#1B3B28]"}`}>Centro di Parodontologia</span>
      <span className={`f-mono block whitespace-nowrap text-[0.5rem] sm:text-[0.58rem] tracking-[0.24em] uppercase mt-1 ${dark ? "text-[#86C89B]" : "text-[#526356]"}`}>
        Parodontologia laser
      </span>
    </span>
  </span>
);
